import { Dialog, Stack, Text, Box, Heading, Button, useToast } from '@machobear/design-system'
import { WarningLarge } from '@/components/icons'
import { useTranslation } from 'react-i18next'

type DeleteDialogProps = {
  open: boolean
  onClose: () => void
  onDelete: () => void
}

export const DeleteTrustScoreDialog = ({ open, onClose, onDelete }: DeleteDialogProps) => {
  const showToast = useToast()
  const { t } = useTranslation()

  const handleDelete = async () => {
    onDelete()
    onClose()
  }

  return (
    <Dialog id="delete-trust-score-dialog" width="xsmall" open={open} onClose={onClose}>
      <Stack space="gutter" align="center">
        <WarningLarge />
        <Stack space="small">
          <Heading level="6" align="center">
            {t(
              'l.standalone_trustscore.list.delete_modal.heading',
              'Are you sure you want to delete?'
            )}
          </Heading>
          <Text align="center">
            {t(
              'l.standalone_trustscore.list.delete_modal.text',
              'This will permanently delete your Trust Score and it cannot be recovered.'
            )}
          </Text>
        </Stack>
      </Stack>
      <Box display="flex" flexDirection="row" paddingTop="large" gap="xsmall">
        <Button variant="transparent" onClick={onClose}>
          {t('l.standalone_trustscore.list.delete_modal.cancel', 'Cancel')}
        </Button>
        <Button variant="solid" tone="critical" onClick={handleDelete}>
          {t('l.standalone_trustscore.list.delete_modal.delete_confirmation', 'Yes, delete')}
        </Button>
      </Box>
    </Dialog>
  )
}
